<template>
  <component :is="componentType" v-if="title" :url="url" :title="title" class="w-full cursor-pointer">
    <span class="flex items-center mb-2">
      <div class="flex leading-5 border-b-2 hover:border-app-green border-transparent uppercase">
        {{ title }}
      </div>
      <AtomIconArrowRight v-if="hasArrow" class="flex inline-block ml-auto mr-8 w-3 h-3" />
    </span>
  </component>
</template>

<script setup lang="ts">
interface Props {
  title: string
  url?: string
  hasArrow?: boolean
}

const props = defineProps<Props>()

const AtomLink = resolveComponent('AtomLink')
const componentType = props.url ? AtomLink : 'button'
</script>
